<template>
  <div
    class="accordion"
    :class="accordionClasses"
    v-if="hasExplanationSlot && hasTitleSlot"
  >
    <div class="explanation">
      <div class="content">
        <slot name="explanation"></slot>
      </div>
    </div>
    <h3
      class="title"
      @click="toggleAccordion"
    >
      <slot name="title"></slot>
      <button class="button"></button>
    </h3>
  </div>
</template>

<script>
import { scrollPositionMixin } from '@/mixins'
import { trackAccordion } from '@/utils/track'

export default {
  name: 'Accordion',
  data () {
    return {
      show: false,
      done: false,
      tracked: false
    }
  },
  props: {
    track: {
      type: String,
      required: true
    }
  },
  methods: {
    toggleAccordion () {
      this.show = !this.show
      if (!this.tracked) {
        trackAccordion(this.track)
      }
      this.tracked = true
    }
  },
  mixins: [scrollPositionMixin],
  computed: {
    hasExplanationSlot () {
      return !!this.$slots.explanation
    },
    hasTitleSlot () {
      return !!this.$slots.title
    },
    accordionClasses () {
      return {
        'is-appear': this.done,
        'is-closed': !this.show,
        'is-open': this.show
      }
    }
  },
  watch: {
    reached () {
      if (!this.done) {
        this.done = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.accordion {
  border-radius: 10px;
  background-color: $c-red;
  color: white;
  text-align: left;
  font-size: 18px;
  line-height: 1.44;
  max-width: 500px;
  margin: 50px auto 0;
  transition: all 3s cubic-bezier(.19,1,.22,1);
  position: relative;
  z-index: 1;
  opacity: 0;
  transform: translateY(25px);
}
.is-appear {
  opacity: 1;
  transform: translateY(0px);
}
.explanation {
  margin: 0 auto;
  max-height: 800px;
  overflow: hidden;
  transition: 1500ms cubic-bezier(.19,1,.22,1) all;
  will-change: max-height;
}
.content {
  padding: 45px 30px 40px;
  opacity: 1;
  will-change: opacity, transform;
  transform: translateY(0px);
  transition: 1s cubic-bezier(.19,1,.22,1) all 0ms;
}
.title {
  font-size: 16px;
  cursor: pointer;
  text-align: left;
  padding: 24px 30px;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    height: 26px;
    left: 0;
    right: 0;
    background-image: linear-gradient(to bottom, rgba($c-dark, 0), rgba($c-dark, 0.05));
    opacity: 1;
    top: -26px;
    z-index: 1;
    transition: 1s cubic-bezier(.19,1,.22,1) all 0ms;
  }
}
.button {
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  background-color: transparent;
  border: none;
  outline: 0;
  cursor: pointer;

  &:before, &:after {
    content: '';
    position: absolute;
    right: 0;
    width: 13px;
    border-bottom: 2px solid white;
    border-radius: 1px;
  }
  &:after {
    transform: rotate(0deg);
  }
}
.is-closed {
  .explanation {
    max-height: 0px;
    transition-duration: 0.5s;
  }
  .content {
    opacity: 0;
    transform: translateY(8px);
  }
  .button:after {
    transform: rotate(90deg);
  }
  .title:before {
    opacity: 0;
    transition-delay: 0s;
    transition-duration: 0.5s;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Accordion.vue